import styled from 'styled-components';

const Separator = styled.div`
  margin: 5px;
  display: inline-block;
`;

export default Separator;
